import { getFormattedDate } from '../../../../helpers/localize';
import DownloadTableFile from '../../../Shared/Table/widgets/TopBar/DownloadTableFile';
import MetricsButton from '../../../Shared/Table/widgets/MetricsButton';
import { TABLE_KEYS } from '../../../../redux_store';
import { useSelector } from 'react-redux';

const TableActions = (props) => {
  const { isDistributionSponsor } = useSelector((state) => state.user);
  const tableKey = isDistributionSponsor ? TABLE_KEYS.resourcesDSTable : TABLE_KEYS.resourcesTable;

  return <>
    <MetricsButton title={'resource'} aggregations={props.aggregations} filter={props.tableFilter} />
    <DownloadTableFile
      fileName={`Resources ${getFormattedDate(new Date(Date.now()))}.csv`}
      endpoint={'/export-resources.csv'}
      tableKey={tableKey}
      {...props}
    />
  </>;
};

export default TableActions;
